import React from "react";
import { useNavigate } from "react-router-dom";

const HRMS = () => {
  const navigate = useNavigate();

  return (
    <section className="menu-section-bg">
      <div className="menu-container">

        {/* ===== HEADER ===== */}
        <div className="product-subtitleBg-header">
          <h1 className="product-titleBg">
            Human Resource Management System (HRMS)
          </h1>
          <p className="product-subtitleBg">
            Simplify staff management, payroll, biometric attendance, performance appraisals,
            and recruitment designed specifically for educational institutions.
          </p>
        </div>

        {/* ===== SECTION 1 ===== */}
        <div className="product-and-sol-mainCard ps-two-column-grid product-sol-card">
          <div className="enrollment-image-card product-sol-card-imageBox">
            <img
              src="../images/product&soluction/education-academy-certification-curriculum.jpg"
              alt="HRMS Staff Portal"
              className="ps-main-image"
            />
          </div>

          <div>
            <h2 className="product-and-sol-sectionTitle">
              Comprehensive Staff & Payroll Management
            </h2>
            <p className="product-and-sol-section-text">
              Manage your school faculty, administrative staff, and support teams efficiently.
              Streamline automated payroll, track leaves, evaluate teacher performance,
              and maintain fully compliant employee records.
            </p>

            <ul className="product-and-sol-list">
              <li>✔ Automated staff payroll & salary processing</li>
              <li>✔ Biometric & mobile attendance integration</li>
              <li>✔ Faculty workload & timetable assignment</li>
              <li>✔ Teacher performance evaluations & KPIs</li>
            </ul>

            <div
              className="read-more-btn"
              onClick={() => window.open("https://hr.mdisu.in/", "_blank")}
            >
              Visit HRMS Portal →
            </div>
          </div>
        </div>

        {/* ===== SECTION 2 ===== */}
        <div className="product-and-sol-secondCard ps-two-column-grid product-sol-card">
          <div>
            <h2 className="product-and-sol-sectionTitle">
              Empower School HR & Administrative Teams
            </h2>
            <p className="product-and-sol-section-text">
              School HR requirements differ significantly from corporate businesses.
              From seasonal hiring and substitute teacher dispatching to compliance documentation,
              our HRMS automates workforce administration end-to-end.
            </p>

            <ul className="product-and-sol-list">
              <li>✔ Eliminates manual payroll calculation errors</li>
              <li>✔ Simplifies leave requests & approval workflows</li>
              <li>✔ Tracks faculty certifications & qualifications</li>
              <li>✔ Enhances staff retention & appraisal clarity</li>
              <li>✔ Secure role-based staff data management</li>
            </ul>

            <div
              className="read-more-btn"
              onClick={() => window.open("https://hr.mdisu.in/", "_blank")}
            >
              Access HRMS Portal →
            </div>
          </div>

          <div className="student-image-card product-sol-card-imageBox">
            <img
              src="../images/product&soluction/Admission&Enrollment1.jpg"
              alt="School HR Team"
              className="ps-main-image"
            />
          </div>
        </div>

        {/* ===== FEATURES ===== */}
        <div className="ps-feature-grid">

          <FeatureCard
            typeClass="credentialing"
            backgroundColor="#e9fdf3"
            icon={icons.payroll}
            title="Payroll & Salary Processing"
            description="Automated salary calculation, tax deductions, PF/ESI reports, and instant payslip generation."
          />

          <FeatureCard
            typeClass="wallet"
            backgroundColor="#f3ecff"
            icon={icons.attendance}
            title="Leave & Attendance"
            description="Biometric sync, shift timing tracking, leave balances, and substitute teacher management."
          />

          <FeatureCard
            typeClass="human-resources"
            backgroundColor="#f1f6ff"
            icon={icons.staff}
            title="Staff Directory & Records"
            description="Complete digital personnel files with qualification documents, contracts, and service history."
          />

          <FeatureCard
            typeClass="education"
            backgroundColor="#fff3cc"
            icon={icons.appraisal}
            title="Performance Appraisals"
            description="Structured evaluation metrics, KPI tracking, self-assessments, and review cycles."
          />

          <FeatureCard
            typeClass="marketing"
            backgroundColor="#ffe6dc"
            icon={icons.recruitment}
            title="Recruitment & Onboarding"
            description="Job posting, applicant tracking, background checks, and automated onboarding workflows."
          />

          <FeatureCard
            typeClass="analytics"
            backgroundColor="#eaf9fa"
            icon={icons.analytics}
            title="HR Analytics & Reports"
            description="Real-time staff attendance summaries, payroll summaries, and compliance audit reports."
          />

        </div>

        {/* ===== CTA ===== */}
        <div className="ps-highlight-wrapper">
          <div className="ps-highlight-card">

            <div className="ps-highlight-header">
              <h2 className="ps-highlight-title">
                Modernize School HR & Payroll Operations
              </h2>
              <p className="ps-highlight-subtitle">
                Save administrative time and support your faculty
              </p>
            </div>

            <div className="ps-highlight-body">
              <p className="ps-highlight-text">
                Transform your school HR processes into an automated, error-free management system.
              </p>

              <div className="ps-button-group">
                <a
                  href="https://hr.mdisu.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="Demo-button"
                  style={{ textDecoration: "none", display: "inline-block", textAlign: "center" }}
                >
                  Visit HRMS Portal
                </a>
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
};

/* ===== SHARED FEATURE CARD ===== */
const FeatureCard = ({
  icon,
  title,
  description,
  backgroundColor,
  typeClass
}) => (
  <div
    className={`card product-soluction-card ${typeClass}`}
    style={{ backgroundColor }}
  >
    <div className="card-overlay"></div>

    <div className="circle">
      <div className="ps-card-icon">{icon}</div>
    </div>

    <h3 className="ps-card-title">{title}</h3>
    <p className="product-soluction-card-text">{description}</p>
  </div>
);

/* ===== ICONS ===== */
const icons = {
  payroll: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <rect x="2" y="6" width="20" height="12" rx="2" stroke="#5a5cff" strokeWidth="2" />
      <circle cx="12" cy="12" r="3" stroke="#5a5cff" strokeWidth="2" />
      <path d="M6 12h.01M18 12h.01" stroke="#5a5cff" strokeWidth="2" />
    </svg>
  ),
  attendance: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <path d="M12 8v4l3 3" stroke="#ff8c00" strokeWidth="2" strokeLinecap="round" />
      <circle cx="12" cy="12" r="9" stroke="#ff8c00" strokeWidth="2" />
    </svg>
  ),
  staff: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="7" r="4" stroke="#0ca85c" strokeWidth="2" />
      <path d="M5 21c0-4 14-4 14 0" stroke="#0ca85c" strokeWidth="2" />
    </svg>
  ),
  appraisal: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" stroke="#e74c3c" strokeWidth="2" strokeLinejoin="round" />
    </svg>
  ),
  recruitment: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="#6c5ce7" strokeWidth="2" />
      <circle cx="8.5" cy="7" r="4" stroke="#6c5ce7" strokeWidth="2" />
      <line x1="20" y1="8" x2="20" y2="14" stroke="#6c5ce7" strokeWidth="2" strokeLinecap="round" />
      <line x1="17" y1="11" x2="23" y2="11" stroke="#6c5ce7" strokeWidth="2" strokeLinecap="round" />
    </svg>
  ),
  analytics: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <path d="M3 3v18h18" stroke="#0097e6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18 17V9M13 17V5M8 17v-4" stroke="#0097e6" strokeWidth="2" strokeLinecap="round" />
    </svg>
  ),
};

export default HRMS;
